<div class="grid flex justify-content-center">
  <div class="col-12 flex align-items-center justify-content-center">
    <div class="card">
      <h4 class="m-0">{{ settings.title }}</h4>
      <br />
      <p-progressBar
        *ngIf="listingData"
        mode="indeterminate"
        [style]="{ height: '6px' }"
      ></p-progressBar>
      <p-table
        #dt
        [value]="data"
        [columns]="selectedColumns"
        [rows]="10"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        selectionMode="single"
        [rowHover]="true"
        dataKey="id"
        rowExpandMode="single"
        [responsive]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [reorderableColumns]="true"
        styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm"
      >
        <ng-template pTemplate="caption">
          <div
            class="flex md:justify-content-between md:align-items-center mt-2"
          >
            <div class="flex align-items-center justify-content-center">
              <p-multiSelect
                [options]="settings.columns"
                [(ngModel)]="selectedColumns"
                optionLabel="header"
                selectedItemsLabel="{0} columnas seleccionadas"
                [style]="{ width: '100%' }"
                placeholder="Filtrar Columna"
                class="mt-0 mb-2 md:mt-0"
              ></p-multiSelect>
              <span class="block ml-3 mb-2 p-input-icon-left w-24rem">
                <i class="pi pi-search"></i>
                <input
                  style="width: 100%"
                  pInputText
                  type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="Buscar..."
                />
              </span>
            </div>
            <div class="flex align-items-center justify-content-center mb-2">
              <ng-container *ngIf="settings.exportData">
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file"
                  (click)="dt.exportCSV()"
                  class="mr-2"
                  pTooltip="CSV"
                  tooltipPosition="bottom"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-excel"
                  (click)="exportExcel()"
                  class="p-button-success mr-2"
                  pTooltip="XLS"
                  tooltipPosition="bottom"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-pdf"
                  (click)="exportPdf()"
                  class="p-button-warning mr-2"
                  pTooltip="PDF"
                  tooltipPosition="bottom"
                ></button>
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th
              *ngFor="let col of selectedColumns"
              pSortableColumn="{{ col.field }}"
            >
              {{ col.header }}
              <p-sortIcon field="{{ col.field }}"></p-sortIcon>
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
          <tr>
            <th style="width: 3rem"></th>
            <th *ngFor="let col of selectedColumns">
              <input
                id="filterColumn"
                pInputText
                style="width: 75%; max-width: 75%"
                type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')"
              />
            </th>
            <th *ngFor="let action of actions"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr
            [pSelectableRow]="rowData"
            [ngClass]="{ 'row-priceless': rowData.statusPriceId == '1' }"
          >
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="rowData"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                (click)="onSelectParent(rowData)"
              ></button>
            </td>
            <td *ngFor="let col of selectedColumns; let i = index">
              <span class="p-column-title">{{ col.header }} </span>
              <p
                *ngIf="
                  selectedColumns[i].pipe !== 'Uppercase' &&
                  selectedColumns[i].pipe !== 'Currency' &&
                  selectedColumns[i].pipe !== 'Date' &&
                  selectedColumns[i].pipe !== 'Percent' &&
                  selectedColumns[i].pipe !== 'Boolean' &&
                  selectedColumns[i].tag !== 'tagStatus'
                "
              >
                {{ rowData[col.field] }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Uppercase'">
                {{ rowData[col.field] | uppercase }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Currency'">
                {{ rowData[col.field] | currency: 'PEN' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Date'">
                {{ rowData[col.field] | date: 'shortDate' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Percent'">
                {{ rowData[col.field] | percent: '2.0-2' }}
              </p>
              <p *ngIf="selectedColumns[i].pipe === 'Boolean'">
                <span *ngIf="rowData[col.field] === 1">SI</span>
                <span *ngIf="rowData[col.field] === 0">NO</span>
              </p>
              <p-tag *ngIf="selectedColumns[i].tag === 'tagStatus'"
                     [style]="{'background': rowData['tagStatusColor']}"
                     [severity]="rowData['statusTag']">
                {{rowData[col.field]}}
              </p-tag>
            </td>
            <td *ngFor="let action of actions">
              <button
                pButton
                pRipple
                [icon]="action.icon"
                [class]="action.class"
                (click)="actionRow(action, rowData)"
                [pTooltip]="action.pTooltip"
                tooltipPosition="left"
              ></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData>
          <tr>
            <td
              [colSpan]="
                mathMax(childSettings.columns.length, settings.columns.length) +
                1
              "
            >
              <div class="flex justify-content-center">
                <div class="flex align-items-center justify-content-center">
                  <div class="p-3">
                    <ami-table-actions
                      [settings]="settingsByChild[rowData.id]"
                      [data]="childProductsByParent[rowData.id]"
                      [actions]="childActions"
                      (action)="actionChildRow($event)"
                      [showSearchHelpers]="showSearchHelpersOfChild"
                    >
                    </ami-table-actions>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
